export class MenuCategoryAvailabilityDto {
    all: number;
    active: number;
    inactive: number;
}